import { NoddiAsyncError } from 'noddi-types';
import { commonTexts, getInternalErrorMessage } from 'noddi-util';
import { NoddiButton } from '../../Inputs/NoddiButton';
import { NoddiInfoBanner } from '../NoddiInfoBanner';
import type { ApiErrorMessageProps } from './types';

type Props = Pick<ApiErrorMessageProps, 'onRetry' | 'isRetrying'> & {
  error: NoddiAsyncError | (NoddiAsyncError | null)[];
};

export function ApiErrorMessageInternal({ error, onRetry, isRetrying }: Props) {
  const errorDescription = getInternalErrorMessage(error);

  return (
    <div className='mt-2'>
      <NoddiInfoBanner
        variant='error'
        texts={[{ value: errorDescription }]}
        actionNode={
          onRetry && (
            <NoddiButton variant='outline' size='small' loading={isRetrying} onClick={onRetry}>
              {commonTexts.errors.tryAgain}
            </NoddiButton>
          )
        }
      />
    </div>
  );
}
